import { OktaAuth } from '@okta/okta-auth-js'

const oktaConfig = {
    issuer: process.env.REACT_APP_OKTA_ISSUER || '',
    redirectUri: `${window.location.origin}/implicit/callback`,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '',
    scopes: ['openid', 'email', 'profile', 'groups'],
    pkce: true,
}

export const oktaAuth = new OktaAuth(oktaConfig)

// Expose to microfrontends
;(window as any).__CONTAINER_OKTA_AUTH__ = oktaAuth
;(window as any).__CONTAINER_ENV__ = {
    REACT_APP_OKTA_ISSUER: process.env.REACT_APP_OKTA_ISSUER,
    REACT_APP_APPSYNC_LOCAL_CLEARANCE_ENDPOINT: process.env.REACT_APP_APPSYNC_LOCAL_CLEARANCE_ENDPOINT,
    REACT_APP_APPSYNC_LOCAL_CLEARANCE_ENDPOINT_NEW: process.env.REACT_APP_APPSYNC_LOCAL_CLEARANCE_ENDPOINT_NEW,
    REACT_APP_APPSYNC_LOCAL_CLEARANCE_HTTP_ENDPOINT: process.env.REACT_APP_APPSYNC_LOCAL_CLEARANCE_HTTP_ENDPOINT,
    REACT_APP_PRODUCT_WEIGHTS_HOST: process.env.REACT_APP_PRODUCT_WEIGHTS_HOST,
    REACT_APP_S3_PAYLOAD_BUCKET: process.env.REACT_APP_S3_PAYLOAD_BUCKET,
}
